<template>
  <div class="animate-pulse rounded-md bg-slate-200"></div>
</template>

<script>
export default {
  setup() {},
};
</script>
